import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { ISalesInvoicesReturnsResponse } from "@api/stores/salesInvoices/returns/types";

import type { IPathBaseParam, IPathByIdParam } from "./path";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ISalesInvoicesReturnsResponse>>,
  IPathBaseParam,
  IPaginationParams
>("stores.salesInvoiceReturns");

const getApis = createGetApi<
  IApiResponse<ISalesInvoicesReturnsResponse>,
  IPathByIdParam,
  object
>("stores.salesInvoiceReturns");

export const salesInvoiceReturns = {
  ...getAllApis,
  ...getApis,
};
